module.exports = __webpack_public_path__ + "assets/img/s3-subtitle-2-ec1e02f9.png";